import getCalendarFoldersService from 'mini-calendar-store/lib/services/getCalendarFoldersService';
import isStartupDataEnabled from 'bootstrap/lib/isStartupDataEnabled';
import { earlyCalendarEventsFetch } from './earlyCalendarEventsFetch';
import { earlyProcessingForMini } from 'mini-early-processing/lib/earlyProcessingForMini';
import { getMiniAnalyticsOptions } from 'mini-app-analytics';
import { getStartupBootPromise } from 'bootstrap/lib/getStartupBootPromise';
import { handleBootErrorForMini } from 'mini-auth-error-handler/lib/handleBootErrorForMini';
import { LazyAction, LazyBootModule } from 'owa-bundling-light';
import { OwaWorkload } from 'owa-workloads';
import { ServerAppName } from 'data/lib/mini-app-constants';
import { SessionData } from 'owa-service/lib/types/SessionData';
import { sharedStart } from 'owa-shared-start/lib/sharedStart';
import { updateBaseUrlAndHandleAuthError } from 'mini-auth-error-handler/lib/updateBaseUrlAndHandleAuthError';

const lazyModule = new LazyBootModule(
    () => import(/* webpackChunkName: "CalendarBoot" */ './lazyIndex')
); //this should be first, as it sets cdn url for webpack

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function startCalendarBootstrap() {
    sharedStart({
        app: ServerAppName.MiniCalendar,
        startupAriaToken: getMiniAnalyticsOptions().ariaTenantTokens[0],
        overrideBootPromises: isStartupDataEnabled()
            ? getStartupBootPromise(ServerAppName.MiniCalendar)
            : null,
        runAfterRequests: (sessionDataPromise: Promise<SessionData>) => {
            // This will fetch folders twice for direct calendar start as a side-effect for a week
            // before we graduate startup data. However this is needed to avoid a sequential download of data
            updateBaseUrlAndHandleAuthError(sessionDataPromise);
            getCalendarFoldersService();
            earlyProcessingForMini(OwaWorkload.Calendar, sessionDataPromise);
            earlyCalendarEventsFetch();
        },
        bootstrap: new LazyAction(lazyModule, m => m.bootstrapCalendarModule),
        handleBootError: handleBootErrorForMini,
    });
}
